import React from 'react';

const BriefcaseIcon = ({ color = '#424242', width = 20, height = 21, ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      ref={ref}>
      <path
        d="M2.5 10.5C2.5 13.6427 2.5 16.8807 3.59835 17.857C4.6967 18.8333 6.46447 18.8333 10 18.8333C13.5355 18.8333 15.3033 18.8333 16.4016 17.857C17.5 16.8807 17.5 13.6427 17.5 10.5"
        stroke={color}
        strokeWidth="1.38459"
      />
      <path
        d="M12.2143 12.3349L17.379 10.7855C17.7214 10.6828 17.8926 10.6314 18.0194 10.5296C18.1301 10.4406 18.2162 10.3249 18.2696 10.1933C18.3307 10.0426 18.3307 9.86385 18.3307 9.50638C18.3307 8.10023 18.3307 7.39715 18.056 6.86056C17.8169 6.39369 17.437 6.01383 16.9702 5.77476C16.4336 5.5 15.7305 5.5 14.3244 5.5H5.67044C4.26429 5.5 3.56122 5.5 3.02463 5.77476C2.55775 6.01383 2.17789 6.39369 1.93882 6.86056C1.66406 7.39715 1.66406 8.10023 1.66406 9.50638C1.66406 9.86385 1.66406 10.0426 1.7252 10.1933C1.77859 10.3249 1.86472 10.4406 1.97542 10.5296C2.10218 10.6314 2.27338 10.6828 2.61578 10.7855L7.78046 12.3349"
        stroke={color}
        strokeWidth="1.38459"
      />
      <path
        d="M11.668 10.918H8.33464C8.10452 10.918 7.91797 11.1045 7.91797 11.3346V13.1359C7.91797 13.3062 8.0217 13.4595 8.17989 13.5227L8.76333 13.7561C9.55804 14.074 10.4446 14.074 11.2393 13.7561L11.8227 13.5227C11.9809 13.4595 12.0846 13.3062 12.0846 13.1359V11.3346C12.0846 11.1045 11.8981 10.918 11.668 10.918Z"
        stroke={color}
        strokeWidth="1.38459"
        strokeLinecap="round"
      />
      <path
        d="M7.64453 3.83073C7.98773 2.85974 8.91376 2.16406 10.0023 2.16406C11.0908 2.16406 12.0168 2.85974 12.36 3.83073"
        stroke={color}
        strokeWidth="1.38459"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default React.forwardRef(BriefcaseIcon);
